export const introduce = {
  text: '新增地址量统计了区块链网络中，首次出现在交易里的地址数量（过滤重复地址）。',
  height: 1200,
};
